export default function FrontierChart({ data }) {
  if (!data) return null;
  const { portfolios, maxSharpe, minVol, current } = data;
  const W=560, H=300, PL=52, PR=20, PT=18, PB=42;
  const cW=W-PL-PR, cH=H-PT-PB;

  const allV=[...portfolios.map(p=>p.vol),current.vol];
  const allR=[...portfolios.map(p=>p.ret),current.ret];
  const mnV=Math.max(0,Math.min(...allV)*0.85), mxV=Math.max(...allV)*1.12;
  const mnR=Math.min(...allR)*(Math.min(...allR)<0?1.15:0.8), mxR=Math.max(...allR)*1.15;

  const xs=v=>PL+((v-mnV)/(mxV-mnV||1))*cW;
  const ys=r=>H-PB-((r-mnR)/(mxR-mnR||1))*cH;
  const pct=v=>`${(v*100).toFixed(0)}%`;

  const mnSh=Math.min(...portfolios.map(p=>p.sharpe));
  const mxSh=Math.max(...portfolios.map(p=>p.sharpe));
  const dotClr=sh=>{
    const t=Math.max(0,Math.min(1,(sh-mnSh)/(mxSh-mnSh||1)));
    return `hsl(${220-t*160},${55+t*35}%,${38+t*28}%)`;
  };

  const xTicks=[0,1,2,3,4,5].map(i=>mnV+i*(mxV-mnV)/5);
  const yTicks=[0,1,2,3,4].map(i=>mnR+i*(mxR-mnR)/4);

  return (
    <div style={{overflowX:"auto"}}>
      <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{display:"block",minWidth:280}}>
        {yTicks.map(r=><line key={r} x1={PL} x2={W-PR} y1={ys(r)} y2={ys(r)} stroke="rgba(255,255,255,0.05)" strokeWidth={1}/>)}
        {portfolios.map((p,i)=><circle key={i} cx={xs(p.vol)} cy={ys(p.ret)} r={2.5} fill={dotClr(p.sharpe)} opacity={0.6}/>)}
        <circle cx={xs(minVol.vol)} cy={ys(minVol.ret)} r={6} fill="none" stroke="#60A5FA" strokeWidth={2}/>
        <text x={xs(minVol.vol)+9} y={ys(minVol.ret)+4} fill="#60A5FA" fontSize={9} fontWeight="700">Min Risk</text>
        <circle cx={xs(maxSharpe.vol)} cy={ys(maxSharpe.ret)} r={7} fill="#00C805" stroke="#000" strokeWidth={1.5}/>
        <text x={xs(maxSharpe.vol)+10} y={ys(maxSharpe.ret)+4} fill="#00C805" fontSize={9} fontWeight="700">Best Sharpe</text>
        <circle cx={xs(current.vol)} cy={ys(current.ret)} r={8} fill="#e8c875" stroke="#000" strokeWidth={2}/>
        <text x={xs(current.vol)+11} y={ys(current.ret)+4} fill="#e8c875" fontSize={9} fontWeight="700">You</text>
        <line x1={PL} x2={W-PR} y1={H-PB} y2={H-PB} stroke="rgba(255,255,255,0.12)" strokeWidth={1}/>
        {xTicks.map(v=>(
          <g key={v}>
            <line x1={xs(v)} x2={xs(v)} y1={H-PB} y2={H-PB+4} stroke="rgba(255,255,255,0.15)" strokeWidth={1}/>
            <text x={xs(v)} y={H-PB+15} textAnchor="middle" fill="rgba(255,255,255,0.35)" fontSize={9}>{pct(v)}</text>
          </g>
        ))}
        <line x1={PL} x2={PL} y1={PT} y2={H-PB} stroke="rgba(255,255,255,0.12)" strokeWidth={1}/>
        {yTicks.map(r=>(
          <text key={r} x={PL-6} y={ys(r)+4} textAnchor="end" fill="rgba(255,255,255,0.35)" fontSize={9}>{pct(r)}</text>
        ))}
        <text x={W/2} y={H-4} textAnchor="middle" fill="rgba(255,255,255,0.25)" fontSize={9}>Annualized Volatility (Risk) →</text>
        <text x={12} y={H/2} textAnchor="middle" fill="rgba(255,255,255,0.25)" fontSize={9} transform={`rotate(-90,12,${H/2})`}>↑ Expected Return</text>
      </svg>
    </div>
  );
}
